var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21,10 L21,26.911 L25.6637085,25.6568542 L20.0068542,31.3137085 L14.35,25.6568542 L19,26.908 L19,10 L21,10 Z",
    transform: "rotate(-180 20.007 20.657)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/less.71db9e1f.svg";
export { ForwardRef as ReactComponent };